import React from "react";
import { renderHTML } from "../hooks/htmlToText";
import { useTranslation } from "react-i18next";

export const FAQ = () => {
  const { t } = useTranslation();
  const faqArray = t("faq.faqs", { returnObjects: true }) as {
    question: string;
    answer: string;
  }[];
  return (
    <div id="faq">
      <div className="flex flex-col gap-[64px] lg:gap-[56px] justify-center items-center mx-auto">
        <p className="text-primary-700 text-center font-600 text-[32px] lg:text-[40px] tracking-[-1.2px]">
          {String(t("faq.title"))}
        </p>
        <div className="flex flex-col gap-[64px] lg:gap-[80px] w-[90%] justify-center items-center md:w-[690px]">
          {faqArray.map((eachFAQ, index) => (
            <div className="flex flex-col gap-4 md:px-6-res" key={index}>
              <p className="text-primary-700  text-[24px] font-600">
                {eachFAQ.question}
              </p>
              <p className="text-neutral-200  text-[18px] font-500">
                {renderHTML(eachFAQ.answer)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
